import React, { useContext } from 'react';
import { Tooltip } from 'antd';
import { ConfigContext } from 'contexts/ConfigContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getStyledName } from 'utils/modelName';
import FavouritesIcon from 'components/Favourites/FavouritesIcon';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import ModelFeaturesList from 'components/Model/ModelFeaturesList';
import useModelFeatures from 'hooks/useModelFeatures';

const ModelCover = ({ model, onModelClick, isMobile }) => {

    const modelIDs = { modelID: model.ModelID, packageModelID: model.ID }
    const { clientConfig } = useContext(ConfigContext);
    const { modelFeatures } = useModelFeatures(model);

    let modelNameStyle = null;
    if (clientConfig.grid && clientConfig.grid.nameStyle) {
        modelNameStyle = clientConfig.grid.nameStyle;
    }

    let showFeatures = true;
    if (clientConfig.grid && clientConfig.grid.showFeatures) {
        showFeatures = clientConfig.grid.showFeatures;
    }

    const playlist = model.Playlists[0];

    const handleClick = model => () => {
        onModelClick(model);
    };

    return (
        <div className='model-cover'>
            <div className='model-cover-img-wrapper' onClick={handleClick(model)}>
                <img src={playlist.CoverUrlBig} alt={model.Name} />
                {showFeatures && (
                <div className="model-features-overlay">
                    <ModelFeaturesList
                        modelFeatures={modelFeatures}
                        nameTag="span"
                        valueTag="em"
                    />
                </div>
                )}
            </div>
            <div className="model-name">
                <h3 onClick={handleClick(model)}>
                    {getStyledName(model, modelNameStyle)}
                </h3>
                <div className="model-icons">
                    {model.Note &&
                        <Tooltip
                            title={model.Note}
                            trigger={isMobile ? 'click' : 'hover'}
                        >
                            <FontAwesomeIcon style={{ cursor: 'pointer' }} icon={icon({ family: 'sharp', name: 'message-lines', style: 'light' })}  />
                        </Tooltip>
                    }
                    <FavouritesIcon modelIDs={modelIDs} />
                </div>
            </div>
        </div>
    )
}

export default ModelCover
